export enum ApplianceTypeEnums {
	Empty = 0,
	Soft = 1,
	Hard = 2,
	DualLaminate = 3
}
